import React from "react";

// Components
import { Modal, Flex } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import CustomTitle from "./CustomTitle";
import CustomParagraph from "./CustomParagraph";

const CustomModalWithoutButtons = ({
  modalOpen,
  setModalOpen,
  modalTitle,
  modalText,
  modalSize,
  children,
  modalBorderRadius = "8px",
  headerIcon,
  fontSize="28px",
  lineHeight="36px",
  modalTextFontSize="14px"

}) => {
  const handleCancel = () => {
    setModalOpen(false);
  };

  return (
    <Modal
      title=""
      centered
      open={modalOpen}
      onCancel={handleCancel}
      width={modalSize}
      footer={null}
      closeIcon={<CloseOutlined style={{ fontSize: "15px", color: "black" }} />}
      styles={{
        content: {
          borderRadius: modalBorderRadius, // Styles for the entire modal content
        },
      }}
    >
      {headerIcon && (
        <Flex justify="center" style={{ marginBottom: '16px' }}>
          {headerIcon}
        </Flex>
      )}

      <Flex vertical 
      // align="center" 
      // style={{ textAlign: 'center' }}
      >
        <CustomTitle
          className="ant-modal-heading"
          text={modalTitle}
          fontSize={fontSize}
          lineHeight={lineHeight}
          fontWeight="700"
          marginBottom="4px"
        />
        {modalText &&
        <CustomParagraph
          text={modalText}
          fontSize={modalTextFontSize}
          fontWeight="400"
          lineHeight="20px"
          marginBottom="24px"
        />
}
      </Flex>

      <main>{children}</main>
    </Modal>
  );
};

export default CustomModalWithoutButtons;
